<div [formGroup]="matrixRowModifyFormGroup" *ngIf="matrixRowModifyFormGroup">
    <mat-icon class="font-size-16" *ngIf="isJointIdEdit">
        <a href="javascript:void(0)" (click)="open(mymodal_joint_edit)" #tooltip="matTooltip" matTooltip="Edit" [matTooltipPosition]="tooltip_position">edit</a>
    </mat-icon>

    <!-- edit modal open -->
    <ng-template #mymodal_joint_edit let-modal>
        <div class="modal-header">
            <h4>Change Joint ID</h4>
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i class="flaticon2-cross"></i></a>
        </div>
        <div class="modal-body output-lable">
            <div class="row">
                <div class="col-md-3" style="padding: 15px">
                    <mat-label class="font-style">Joint ID</mat-label>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="example-full-width custom-text-field">
                        <input
                            type="text"
                            matInput
                            placeholder="New Name Here"
                            formControlName="jointId"
                            name="name"
                            #tooltip="matTooltip"
                            matTooltip="Joint Id is Required"
                            [matTooltipDisabled]="matrixRowModifyFormGroup.get('jointId').valid"
                              (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                        />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn primary-ebtn" (click)="updateJointId()">Ok</button>
            <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">Cancel</button>
        </div>
    </ng-template>
</div>
